import { render, staticRenderFns } from "./TermsPopUp.vue?vue&type=template&id=19cacf6e&scoped=true"
import script from "./TermsPopUp.vue?vue&type=script&lang=js"
export * from "./TermsPopUp.vue?vue&type=script&lang=js"
import style0 from "./TermsPopUp.vue?vue&type=style&index=0&id=19cacf6e&prod&lang=css"
import style1 from "./TermsPopUp.vue?vue&type=style&index=1&id=19cacf6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19cacf6e",
  null
  
)

export default component.exports